import { BaseAction } from '../../store/actions';
import { CreateApplicationApiOptions, Application } from '../../shared/models/application';

export enum ApplicationActions {
  CreateApplicationRequest = '[Application] Start Application Create',
  CreateApplicationSuccess = '[Application] Application Create Success',
  CreateApplicationError = '[Application] Application Create Error',
}

export class CreateApplicationRequest implements BaseAction<ApplicationActions> {
  readonly type = ApplicationActions.CreateApplicationRequest;

  constructor(public readonly apiOptions: CreateApplicationApiOptions) {}
}

export class CreateApplicationSuccess implements BaseAction<ApplicationActions> {
  readonly type = ApplicationActions.CreateApplicationSuccess;

  constructor(public readonly payload: Application) {}
}

export class CreateApplicationError implements BaseAction<ApplicationActions> {
  readonly type = ApplicationActions.CreateApplicationError;

  constructor(public readonly payload: string) {}
}

export type ApplicationAction = CreateApplicationRequest | CreateApplicationSuccess | CreateApplicationError;